// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';

export const resetProductDetails = () => ({
    type: actions.RESET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/reset-product-details.js